module.exports = __webpack_public_path__ + "static/cello_cn-3552b4a0de1387132f401e7d24f93a8a.pdf";